<template>
  <v-container class="gray pa-3 ma-0 fluid subtitle-1 text-justify">
    <h1 class="mt-4">Instalação do Ambiente</h1>
    <br />
    <v-layout>
      <v-flex>
        <v-row>
          <v-col class="col-10 offset-1">
            Alguns
            <i>softwares</i> devem ser instalados antes de começarmos a brincar com Vue e Wails.
          </v-col>

          <v-col class="col-8 offset-2">
            <ul>
              <li>
                <strong>NodeJs</strong>: gerencia a instalação de pacotes e fornece um servidor de teste, bastante simplificado
              </li>
              <li>
                <strong>Compilador C/C++</strong>: é uma exigência do Wails para gerar o executável final
              </li>
              <li>
                <strong>Compilador Go</strong>: a porção mais básica do Wails é em Go
              </li>
              <li>
                <strong>Visual Studio Code</strong>: uma IDE bastante poderosa para podermos trabalhar
              </li>
              <li>
                <strong>Wails</strong>: a ferramenta em si
              </li>
            </ul>
          </v-col>

          <v-col class="col-10 offset-1">Antes de prosseguirmos, saiba que:</v-col>

          <v-col class="col-8 offset-2">
            <ul>
              <li>
                Não será necessário instalar estes
                <i>softwares</i> nas máquinas dos usuários finais do seu sistema
              </li>
              <li>
                Todos os
                <i>softwares</i> citados são gratuitos e de livre utilização
              </li>
              <li>
                Todos os
                <i>softwares</i> citados possuem versões de 32 e de 64 bits
              </li>
              <li>
                Embora eu não tenha testado, todos os
                <i>softwares</i> possuem versões Windows, Linux e MacOs
              </li>
            </ul>
          </v-col>

          <v-col class="col-10 offset-1">
            <strong>Um conselho inicial:&nbsp;</strong>Mesmo que sua máquina de desenvolvimento seja de 64 bits, a instalação das versões de 32 bits dos
            <i>softwares</i> que utilizaremos garante que o seu sistema final poderá ser usado por máquinas de usuários tanto em 32 quanto em 64 bits.
          </v-col>

          <v-col class="col-10 offset-1">
            Vou falar da instalação de cada um destes
            <i>softwares</i>, lembrando sempre que vou utilizar Windows 10 de 64 bits, que é o meu ambiente de desenvolvimento.
          </v-col>

          <v-col class="col-10 offset-1">
            <strong>NodeJs</strong>
          </v-col>

          <v-col class="col-9 offset-2">
            <p>O NodeJS é bastante utilizado no desenvolvimento de aplicações Web.</p>

            <p>
              Atualmente utilizam-se
              <i>frameworks</i> disponíveis no mercado, já que programar aplicações Web escrevendo diretamente em arquivos
              HTML, CSS e JavaScript é um processo trabalhoso e de difícil depuração.
              Os
              <i>frameworks</i> mais utilizados atualmente são Angular, React e VueJs. Todos são semelhantes em suas filosofias, embora
              sua implementação seja diferente. Os três geram ao final código HTML, CSS e JavaScript, e a escolha pela utilização de um ou de outro
              é puramente uma questão de gosto pessoal.
            </p>

            <p>
              O NodeJs é responsável pela instalação de pacotes diversos, tais como o VueJs, o Vuetify e outros pacotes que podem ser utilizados
              em seu sistema. Existem dezenas de pacotes prontos e gratuitos para utilização... Gráficos, roteamento entre páginas, validação de campos,
              comunicação com servidores, requisições HTTP/HTTPS/FTP, tratamento de imagens, Websockets. Existem até pacotes para "conversar" com
              o Google Maps, o que permite colocar um mapa do Google em seu sistema. Enfim, basta existir um pacote JavaScript especializado em
              alguma coisa que o VueJs pode utilizá-lo.
            </p>
          </v-col>

          <v-col class="col-10 offset-1">
            <strong>Compilador C/C++</strong>
          </v-col>

          <v-col class="col-9 offset-2">
            <p>Porque precisamos de um compilador C/C++? Porque o Wails exige!</p>
            <p>
              O Wails, em seu processo de geração da nossa aplicação, compila junto uma biblioteca chamada WebView, escrita
              em C++, que é responsável pelo processamento e renderização de toda a parte frontend da nossa aplicação, ou seja, aquilo
              que fazemos usando o VueJs e transformado pelo próprio VueJs em HTML/CSS/JavaScript.
            </p>
          </v-col>

          <v-col class="col-10 offset-1">
            <strong>Compilador Go</strong>
          </v-col>

          <v-col class="col-9 offset-2">
            <p>
              O Wails utiliza Go para fornecer toda a estrutura necessária para que a parte frontend da nossa aplicação seja processada,
              tanto a parte de lógica do frontend bem como sua renderização na tela, o que é feito através do WebView, que já citamos.
            </p>

            <p>
              Da mesma forma, o Go é utilizado para a programação da parte backend da nossa aplicação. O que podemos fazer no backend? Tudo
              aquilo que o backend de um servidor faria: comunicação com base de dados, verificação de login, upload/download de arquivos, etc.
            </p>

            <p>Quando falarmos de arquiteturas possíveis (e são várias) vou dar exemplos mais práticos de como podemos montar a nossa aplicação</p>
          </v-col>

          <v-col class="col-10 offset-1">
            <strong>Visual Studio Code</strong>
          </v-col>

          <v-col class="col-9 offset-2">
            <p>O Visual Studio Code é uma IDE gratuita, que nos permite trabalhar com todos os tipos de arquivo que comporão nossa aplicação.</p>

            <p>
              Assim como o VueJs, o uso do Visual Studio Code é uma questão de preferência pessoal. Pode ser usado Eclipse, NetBeans, Atom... Enfim,
              use a IDE que gostar mais e se adaptar melhor. Sugiro o VS Code porque me acostumei com ele e no final das contas, ele faz tudo que
              é necessário, além de ser bastante leve em termos de consumo de máquina.
            </p>

            <p>Quando falarmos de arquiteturas possíveis (e são várias) vou dar exemplos mais práticos de como podemos montar a nossa aplicação</p>
          </v-col>

          <v-col class="col-10 offset-1">
            <strong>Wails</strong>
          </v-col>

          <v-col class="col-9 offset-2">
            <p>É a ferramenta central no processo que estamos analisando.</p>

            <p>O que o Wails faz é transformar um site (frontend) e um servidor (backend) em um executável nativo.</p>

            <p>
              Este executável é a aplicação que iremos disponibilizar para nossos usuários, sem que eles tenham como fazer engenharia reversa
              do nosso código.
            </p>
          </v-col>
        </v-row>

        <v-col class="col-10 offset-1">
          Nas próximas seções iremos detalhar como instalar cada um dos
          <i>softwares</i> necessários...
        </v-col>

        <v-row>
          <v-col class="col-1 offset-9">
            <v-btn class="primary" to="/installnode">Instalação do NodeJs</v-btn>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>
    <v-btn fab dark large color="success" fixed right bottom @click="GoTop()">
      <v-icon dark>mdi-arrow-up-bold</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
export default {
  name: "Install",
  mounted() {
    this.$vuetify.goTo(0);
  },
  methods: {
    GoTop() {
      this.$vuetify.goTo(0);
    }
  }
};
</script>
